import React from "react";
import {
  FaArrowLeft,
  FaSearch,
  FaHeart,
  FaBell,
  FaComments,
  FaQuestionCircle,
} from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

function ProfileSidebar() {
  const navigate = useNavigate();

  return (
    <aside className="sidebaryou d-none d-md-flex flex-column align-items-center py-4">

      {/* Back */}
      <button
        className="side-link active bg-transparent border-0"
        data-bs-toggle="tooltip"
        data-bs-placement="bottom"
        title="Back"
        onClick={() => navigate(-1)}   // 🔙 Go Back
      >
        <FaArrowLeft className="icon" />
        <span>Back</span>
      </button>

      {/* Search */}
      <Link
        to="/search"
        className="side-link"
        data-bs-toggle="tooltip"
        data-bs-placement="bottom"
        title="Search"
      >
        <FaSearch className="icon" />
        <span>Search</span>
      </Link>

      {/* Matches */}
      <Link
        to="/my-soulsathi"
        className="side-link"
        data-bs-toggle="tooltip"
        data-bs-placement="bottom"
        title="Matches"
      >
        <FaHeart className="icon" />
        <span>Matches</span>
      </Link>

      {/* Notification */}
      {/* <Link
        to="/notifications"
        className="side-link"
        data-bs-toggle="tooltip"
        data-bs-placement="bottom"
        title="Notifications"
      >
        <FaBell className="icon" />
        <span>Notify</span>
      </Link> */}

      {/* Chats */}
      <Link
        to="/chats"
        className="side-link"
        data-bs-toggle="tooltip"
        data-bs-placement="bottom"
        title="Chats"
      >
        <FaComments className="icon" />
        <span>Chats</span>
      </Link>

      {/* Help */}
      <Link
        to="/help"
        className="side-link"
        data-bs-toggle="tooltip"
        data-bs-placement="bottom"
        title="Help"
      >
        <FaQuestionCircle className="icon" />
        <span>Help</span>
      </Link>
    </aside>
  );
}

export default ProfileSidebar;
